import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// import {useParams}  from 'react-router-dom';
// import { useHistory } from "react-router-dom";
// import axios from 'axios';
// import PDFViewer from 'pdf-viewer-reactjs';

const Story = (props) => {
    const [doc_url, setUrl] = useState(''); 
   
    useEffect(() => {
        setUrl(localStorage.getItem('docurl'));
        console.log('=====>',localStorage.getItem('docurl'));
    },[]);
    return (
        <div>
           {/* <PDFViewer
            document={{
                url: localStorage.getItem('docurl')
            }}
        />  */}
            
        </div>

    );
};

export default Story;